export enum TabsTypeEnum {
  ALL = "all",
  RENDERING = "rendering",
  QCOUPON = "qcoupon",
  FREE = "free",
}

export enum CouponType {
  ALL = -1,
  Animation,
  Qing,
  RenderingMember,
  Expired,
  Freeze,
  Desktop = 8,
}

export enum CouponStatus {
  All = -1,
  BeUsable,
  Expired,
}
// 1 GPU券(仅限GPU，扣费时优先使用本券) 2 CPU券(仅限CPU，扣费时优先使用本券) 3 通用券 4 青云券(CPU青云平台专用) 6 青云券（GPU青云平台专用） undefined 免单券
export enum CouponDetailType {
  GPU = 1,
  CPU,
  Universal,
  CPUQing,
  GPUQing = 6,
}

export const CouponTypeMap = new Map([
  [
    CouponType.Animation,
    {
      type: CouponType.Animation,
      color: "var(--color-coupon)",
      subColor: "var(--color-coupon-sub)",
      tabBgColor: "var(--color-coupon-tab-bg)",
      amountColor: "#ffffff",
      contentBg: "var(--color-coupon-content-bg)",
      contentTitleColor: "var(--color-coupon-content-title)",
      contentColor: "var(--color-coupon-content)",
      buttonColor: "var(--color-coupon-button)",
      buttonBg: "var(--color-coupon-button-bg)",
      borderColor: "var(--color-coupon-border)",
    },
  ],
  [
    CouponType.Qing,
    {
      type: CouponType.Qing,
      color: "#07565B",
      subColor: "#138087",
      tabBgColor: "#13C1C5",
      amountColor: "#ffffff",
      contentBg: "#D0F2F4",
      contentTitleColor: "#2FA5AC",
      contentColor: "#07565B",
      buttonColor: "#0098BA",
      borderColor: "#A5E1E4",
    },
  ],
  [
    CouponType.RenderingMember,
    {
      type: CouponType.RenderingMember,
      color: "#0F328C",
      subColor: "#274DAF",
      tabBgColor: "linear-gradient(90.44deg, #00B2FF 0%, #0047FF 100%);",
      amountColor: "#ffffff",
      contentBg: "#99CBFF",
      contentTitleColor: "#274DAF",
      contentColor: "#122B6D",
      buttonColor: "#5979CB",
      borderColor: "#7B90C7",
    },
  ],
  [
    CouponType.Expired,
    {
      type: CouponType.Expired,
      color: "#55766A",
      subColor: "#6A847B",
      tabBgColor: "#9CAFA7",
      amountColor: "#E1E2E2",
      contentBg: "#F9FFFF",
      contentTitleColor: "#91B3A5",
      contentColor: "#6C9486",
      borderColor: "#C9DBD4",
    },
  ],
  [
    CouponType.Freeze,
    {
      type: CouponType.Freeze,
      color: "#076366",
      subColor: "#137073",
      tabBgColor: "#5f9ea0",
      amountColor: "#E1E2E2",
      contentBg: "#F9FFFF",
      contentTitleColor: "#5F9EA0",
      contentColor: "#5F9EA0",
      borderColor: "#C2F0F2",
    },
  ],
]);

export const CouponContentMap = new Map([
  [
    CouponType.Animation,
    {
      type: CouponType.Animation,
      color: "#00B849",
      text: "coupon_apply_to_animation",
    },
  ],
  [
    CouponType.Qing,
    {
      type: CouponType.Qing,
      color: "#006CFF",
      text: "coupon_apply_to_qing",
    },
  ],
  [
    CouponType.RenderingMember,
    {
      type: CouponType.RenderingMember,
      color: "#FF4444",
      text: "coupon_apply_to_member",
    },
  ],
]);
